'use strict';

import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.css';

import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import 'angular-socket-io';
import 'angular-xeditable';
import 'checklist-model/checklist-model';
import ngDialogs from 'angular-dialog-service';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import ngValidationMatch from 'angular-validation-match';
import ngFileUpload from 'ng-file-upload';

import 'angular-signature/src/signature';

import 'textangular/dist/textAngular-sanitize.min';
import 'textangular/dist/textAngular.min';
import 'textangular/dist/textAngular.css';

import 'expose-loader?moment!moment-timezone';
import 'angular-moment';

import {
  routeConfig,
  schemaFormCustomFields,
  addCustomFieldsCache,
  schemaFormSingleFileUpload,
  addSingleFileUploadCache,
  decorateTextAngular
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import mongooseError from '../components/mongoose-error/mongoose-error.directive';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';

import StorageService from '../components/storage/storage.service';
import HomeComponent from './home/home.component';
import AdminHomeComponent from './admin-home/admin-home.component';


import newlineToHtmlFilter from '../components/newline-to-html/newlineToHtml.filter';

import datatables from 'angular-datatables';
import 'angular-datatables/dist/plugins/buttons/angular-datatables.buttons';
import 'angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css';

import 'datatables.net-responsive/js/dataTables.responsive';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';

import 'datatables.net-buttons';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

import 'datatables.net-rowgroup/js/dataTables.rowGroup.min'

import 'datatables.net-buttons-dt/css/buttons.dataTables.css';

import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable/dist/sortable';

import 'ng-image-gallery/dist/ng-image-gallery';
import 'ng-image-gallery/dist/ng-image-gallery.css';

import 'fullcalendar/dist/fullcalendar.min';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'angular-ui-calendar/src/calendar';

import 'angular-bootstrap-datetimepicker';
import 'angular-bootstrap-datetimepicker/src/css/datetimepicker.css';

import SettingsService from '../components/settings/settings.service';
import SettingsListComponent from './admin/settings-list/settings-list.component';
import SettingsEditComponent from './admin/settings-edit/settings-edit.component';

import DynamicPageComponent from './dynamic-page/dynamic-page.component';
import DynamicPageService from '../components/dynamic-page/dynamic-page.service';

import jsonView from '../components/json-view/json-view.component';
import jsonViewDirective from '../components/json-view/json-view.directive';

// import DataTableComponent from '../components/datatable/datatable.component';

import startFromFilter from '../components/start-from/startFrom.filter';

import FeedbackFormularComponent from '../components/feedback-formular/feedback-formular.component';

import 'bootstrap/js/carousel';

import './app.scss';

import 'angular-ui-codemirror/src/ui-codemirror';

import 'angular-timeline/dist/angular-timeline';
import 'angular-timeline/dist/angular-timeline.css';
import 'angular-timeline/dist/angular-timeline-bootstrap.css';

import HistoryService from '../components/history/history.service';

import ProfileComponent from './user/profile/profile.component';
import ProfilePictureUploadComponent from './user/profile-picture-upload/profile-picture-upload.component';

import 'chart.js/src/chart';
import 'angular-chart.js/angular-chart';

import 'angular-prompt/dist/angular-prompt';

import ClientSettingsComponent from './admin/client-edit/client-edit.component';

import 'pickadate/lib/picker';
import 'pickadate/lib/themes/classic.css';
import 'pickadate/lib/themes/classic.date.css';
import 'pickadate/lib/themes/classic.time.css';

import 'expose-loader?tv4!tv4';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import 'angular-strap';
import 'angular-schema-form-dynamic-select';
import datetimepicker from 'angular-bootstrap-datetimepicker';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

import './schema-form.currency';
import './schema-form.ranking';

import 'angular-tree-control/angular-tree-control';
import 'angular-tree-control/context-menu';
import 'angular-tree-control/css/tree-control.css';
import 'angular-tree-control/css/tree-control-attribute.css';

import 'angular-ui-mask';

import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable/dist/sortable';

import HeaderDropdownMenuComponent from '../components/header-dropdown-menu/header-dropdown-menu.component';

import AssetUploadComponent from '../components/asset-upload/asset-upload.component';

import USPhoneFilter from '../components/us-phone-filter/us-phone.filter';

import CastVoteComponent from './cast-vote/property/cast-vote.component';
import CastContactVoteComponent from './cast-vote/contact/cast-contact-vote.component';
import CastVoteAgreeComponent from '../components/cast-vote-agree/cast-vote-agree.component';

import BallotsService from '../components/ballots/ballots.service';
import BallotsEditComponent from './ballot/ballot-edit/ballot-edit.component';

import VotingsService from '../components/votings/votings.service';
import VotingShowComponent from './voting/voting-show/voting-show.component';
import VotingShowSSComponent from './voting/voting-show-ss/voting-show-ss.component';
import VotingListComponent from './voting/voting-list/voting-list.component';
import VotingEditComponent from './voting/voting-edit/voting-edit.component';
import VoterLookupComponent from '../components/voter-lookup/voter-lookup.component';

import 'pickadate/lib/picker';
import 'pickadate/lib/picker.date';
import 'pickadate/lib/picker.time';

import 'angular-bootstrap-datetimepicker';
import 'angular-schema-form-datepicker/bootstrap-datepicker.min';

import SpecifyProxyComponent from '../components/specify-proxy/specify-proxy.component';

import CalendarComponent from './calendar/calendar.component';

import PaperBallotPropertySelect from './ballot/paper-ballot-property-select/paper-ballot-property-select.component';

import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min';
import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min.css';

import ProxyHolderSelectComponent from './ballot/proxy-holder-select/proxy-holder-select.component';
import ProxyHolderPropertySelectComponent from './ballot/proxy-holder-property-select/proxy-holder-property-select.component';
import RecordVotesComponent from './ballot/record-votes/record-votes.component';

import BallotResultComponent from './ballot/ballot-result/ballot-result.component';

import SignatureModal from '../components/signature-modal/signature-modal.component';
import eform from '../app/e-form';

import IntegrationService from '../components/integration/integration.service';

import survey from '../app/survey';

/* From Suite */

import ContactListComponent from './portfolio/contact-list/contact-list.component';
import ContactEditComponent from './portfolio/contact-edit/contact-edit.component';
import ContactShowComponent from './portfolio/contact-show/contact-show.component';

import PropertyListComponent from './portfolio/property-list/property-list.component';
import PropertyEditComponent from './portfolio/property-edit/property-edit.component';
import PropertyShowComponent from './portfolio/property-show/property-show.component';

import PropertyService from '../components/property/property.service';
import ContactService from '../components/contacts/contacts.service';

import TemplateService from '../components/templates/templates.service';
import TemplateListComponent from './template/template-list/template-list.component';
import TemplateEditComponent from './template/template-edit/template-edit.component';
import TemplateUploadComponent from './template/template-upload/template-upload.component';


import WebaccessListComponent from './webaccess/list/webaccess-list.component';
import WebaccessListSSComponent from './webaccess/list-ss/webaccess-list-ss.component';
import WebaccessEditComponent from './webaccess/edit/webaccess-edit.component';
import WebaccessShowComponent from './webaccess/show/webaccess-show.component';
import WebaccessService from '../components/webaccess/webaccess.service';
import WebaccessResetPasswordComponent from '../components/webaccess-reset-password/webaccess-reset-password.component';
import WebaccessPickerComponent from '../components/webaccess-picker/webaccess-picker.component';

import AddressEditComponent from '../components/address-edit/address-edit.component';
import AddPropertyContactComponent from '../components/add-property-contact/add-property-contact.component';
import ContactLookupComponent from '../components/contact-lookup/contact-lookup.component';
import DTSateService from '../components/datatables-state/datatables-state.service';
import DataTableLoadingPlaceholderComponent from '../components/datatable-loading-placeholder/datatable-loading-placeholder.component';
import EditPropertyContactsComponent from '../components/edit-property-contacts/edit-property-contacts.component';
import InlineDropdownMenuComponent from '../components/inline-dropdown-menu/inline-dropdown-menu.component';
import PropertyLookupComponent from '../components/property-lookup/property-lookup.component';
import SchemaFormModalComponent from '../components/schema-form-modal/schema-form-modal.component';
import ReportFilterModal from '../components/report-filter-modal/report-filter-modal.component';

/* End From suite */

import 'ngstorage/ngStorage.min'
import userList from './admin/user-list';

import VoterGroupListComponent from './voter-group/voter-group-list/voter-group-list.component';
import VoterGroupEditComponent from './voter-group/voter-group-edit/voter-group-edit.component';
import VoterGroupShowComponent from './voter-group/voter-group-show/voter-group-show.component';
import VoterGroupShowSSComponent from './voter-group/voter-group-show-ss/voter-group-show-ss.component';
import VoterGroupsService from '../components/voter-groups/voter-groups.service';

import EFormResultModal from  '../components/eform-result-modal/eform-result-modal.component';

import Messaging from './messaging';

import DataTableViewerComponent from '../components/datatable-view/datatable-view.component';
import AttachmentListComponent from '../components/attachment-list/attachment-list.component';

import GenericLookupComponent from '../components/generic-lookup/generic-lookup.component';

import ClosingSnapshotsService from '../components/closing-snapshots/closing-snapshots.service';

import ContactLookupSSComponent from '../components/contact-lookup-ss/contact-lookup-ss.component';

import EformLinkComponent from '../components/eform-link/eform-link.component';
import BindDynamicPage from '../components/bind-dynamic-page/bind-dynamic-page.directive';
import ShortcodeFilter from '../components/shortcode/shortcode.filter';

import TruncateTextFilter from '../components/truncate-text/truncate-text.filter';

import 'ng-csv/build/ng-csv.min';

import '../components/otp-input-directive/otpInputDirective';

var $stateProviderRef = null;

angular.module('conduu', [ngCookies, ngResource, 'btford.socket-io', uiRouter,
  uiBootstrap, _Auth, account, navbar, footer, main, constants, socket, util, ngValidationMatch,
  mongooseError, 'xeditable', 'checklist-model', ngDialogs, ngFileUpload, datatables,
  newlineToHtmlFilter, StorageService, 'textAngular', 'angularMoment', HomeComponent, SettingsService,
  SettingsListComponent, SettingsEditComponent, 'ui.codemirror', jsonViewDirective, jsonView,
  FeedbackFormularComponent, startFromFilter, 'angular-timeline', HistoryService, 'chart.js','cgPrompt', ProfileComponent,
  ProfilePictureUploadComponent, 'schemaForm', 'mgcrea.ngStrap', datetimepicker, ClientSettingsComponent,
  'treeControl', 'ui.sortable', 'ui.mask', 'cgPrompt', 'ui.calendar', HeaderDropdownMenuComponent,
  AssetUploadComponent, USPhoneFilter, CastVoteComponent, CastVoteAgreeComponent, BallotsService,
  BallotsEditComponent, VotingsService, VotingListComponent, VotingEditComponent, VoterLookupComponent,
  SpecifyProxyComponent, CalendarComponent, "signature", VotingShowComponent, PaperBallotPropertySelect, 'ui.toggle',
  ProxyHolderSelectComponent, ProxyHolderPropertySelectComponent, RecordVotesComponent, BallotResultComponent,
  SignatureModal, eform, IntegrationService, ContactListComponent, ContactEditComponent, ContactShowComponent,
  PropertyListComponent, PropertyEditComponent, PropertyShowComponent, PropertyService, ContactService,
  WebaccessListComponent, WebaccessEditComponent, WebaccessShowComponent, WebaccessService, WebaccessResetPasswordComponent,
  WebaccessPickerComponent, AddressEditComponent, AddPropertyContactComponent, ContactLookupComponent,
  DTSateService, DataTableLoadingPlaceholderComponent, EditPropertyContactsComponent, InlineDropdownMenuComponent,
  PropertyLookupComponent, SchemaFormModalComponent, 'ngStorage', AdminHomeComponent, userList, EFormResultModal,
  VoterGroupListComponent, VoterGroupEditComponent, VoterGroupsService, VoterGroupShowComponent, CastContactVoteComponent,
  Messaging, DataTableViewerComponent, AttachmentListComponent, ReportFilterModal, TemplateService, TemplateListComponent,
  TemplateEditComponent, TemplateUploadComponent, GenericLookupComponent, ClosingSnapshotsService, VoterGroupShowSSComponent,
  VotingShowSSComponent, ContactLookupSSComponent, WebaccessListSSComponent, EformLinkComponent, BindDynamicPage, ShortcodeFilter,
  TruncateTextFilter, 'ngCsv', 'schemaForm-ranking', survey, 'otpInputDirective'
])
  .config(routeConfig)
  .config(schemaFormCustomFields)
  .config(schemaFormSingleFileUpload)
  .config(decorateTextAngular)
  .config(['$provide', function ($provide){
    'ngInject';

    /* Hack to bring UI Bootstrap's Accordeon and UI Sortable together
     * https://stackoverflow.com/questions/26520131/how-can-i-create-a-sortable-accordion-with-angularjs */
    $provide.decorator('uibAccordionDirective', function($delegate) {
      var directive = $delegate[0];
      directive.replace = true;
      return $delegate;
    });
  }])
  .config(['$compileProvider',
    function($compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|conduu):/);
    }
  ])
  .config(function($stateProvider) {
    'ngInject';
    $stateProviderRef = $stateProvider;
  })
  .config(function (ChartJsProvider) {
    'ngInject';
    ChartJsProvider.setOptions("global", { colors : [
      '#97BBCD', // blue
      '#B452CD', // medium orchid
      '#F7464A', // red
      '#46BFBD', // green
      '#FDB45C', // yellow
      '#949FB1', // grey
      '#4D5360'  // dark grey
    ] });
  })
  .run(addCustomFieldsCache)
  .run(addSingleFileUploadCache)
  .run(['$templateCache',function($templateCache){
    $templateCache.put('app/survey/show/campaign-send-confirmation.html',require('./survey/show/campaign-send-confirmation.html'));
  }])
  .run(function($rootScope, $location, Auth, editableOptions) {
    'ngInject';
    // Redirect to main if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/');
        }
      });
    });

    editableOptions.theme = 'bs3';  // xeditable theme = bootstrap 3
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['conduu']);
  });



// WEBPACK FOOTER //
// ./client/app/app.js